import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FluorescentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fluorescent"}/>
}
